import React from 'react'
import { Flex, Skeleton, Space } from 'antd'
import { SkeletonBlock, Well } from '@pushly/aqe/lib/components'
import { VERTICAL_WELL_GAP } from '@pushly/aqe'

const PARAGRAPH_STYLES = {
    paragraph: { marginBottom: 0 },
}

const PARAGRAPH_LABEL_SKELETON_PROPS = {
    active: true,
    title: false,
    paragraph: { rows: 1, width: 120 },
    styles: PARAGRAPH_STYLES,
}
/**
 * Skeleton loading state for the Item Group create/edit form.
 * Mirrors the actual form layout: Details well (name + description fields)
 * and Builder well (rule builder area).
 */
export const ItemGroupFormSkeleton: React.FC = () => (
    <Flex vertical gap={VERTICAL_WELL_GAP}>
        <Well title="Details">
            <Flex vertical gap={16}>
                <Space vertical size={8}>
                    <Skeleton {...PARAGRAPH_LABEL_SKELETON_PROPS} />
                    <Skeleton.Input active size="small" block />
                </Space>
            </Flex>
        </Well>

        <Well
            title="Builder"
            actions={
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 1, width: 120 }}
                    styles={{ paragraph: { ...PARAGRAPH_STYLES.paragraph, alignSelf: 'center' } }}
                />
            }
        >
            <Flex vertical gap={8}>
                <Skeleton {...PARAGRAPH_LABEL_SKELETON_PROPS} />
                <Skeleton.Node active style={{ width: '100%', height: 72 }} />
                <Space>
                    <Skeleton.Button size="small" active style={{ width: 72 }} />{' '}
                    <Skeleton.Button size="small" active style={{ width: 72 }} />
                </Space>
            </Flex>
        </Well>
    </Flex>
)
